{
  "fields": {
    "number": {
      "resultValue": "Result value"
    }
  }
}